// extracted by css-extract-rspack-plugin
export default {"Box":"label-group-module__Box__XNaPu","wrapping":"label-group-module__wrapping__DZtdl"};